// extracted by mini-css-extract-plugin
export default {"feature":"feature___FArac","featureTitle":"featureTitle___k2VTW","featureIcon":"featureIcon___eHteE"};